"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IbETHOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var IbETHOracleFactory = /** @class */ (function (_super) {
    __extends(IbETHOracleFactory, _super);
    function IbETHOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    IbETHOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    IbETHOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    IbETHOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    IbETHOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    IbETHOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return IbETHOracleFactory;
}(contracts_1.ContractFactory));
exports.IbETHOracleFactory = IbETHOracleFactory;
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "CHAIN_LINK_DECIMALS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainlinkEthScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ibETH",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
